<script>
export default {
  computed: {
    invitationCode() {
      return this.$store.state.registration.guest.code.code
    },

    guestData() {
      return this.$store.state.registration.guest.userData
    },

    guestId() {
      return this.guestData ? this.guestData.id : null
    },

    vehicleData() {
      return this.$store.state.registration.guest.vehicle
    },

    vehicleId() {
      return this.vehicleData ? this.vehicleData.id : null
    },

    vehicleInsuranceFile() {
      return this.$store.state.registration.guest.vehicleFiles.insuranceFile
    },

    vehicleDmvFile() {
      return this.$store.state.registration.guest.vehicleFiles.dmvFile
    },

    rulesUrl() {
      return this.$store.state.registration.guest.rulesUrl
    },

    consentUrl() {
      return this.$store.state.registration.guest.consent.url
    }
  }
}
</script>
